import React from "react";
import { Wrapper } from "./Theme";

const Header = ({ Logo, showTimer }) => {
  return (
    <>
      <Wrapper>
        <header>
          <img src={Logo} alt="Logo" />
        </header>
      </Wrapper>
    </>
  );
};

export default Header;
